import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import PropTypes from 'prop-types';
// import './DPDChart.scss';
import './DPDChart.scss';

const DPDChart = ({ data }) => {

  return (
    <>
    <div className='dpd-header'>
      <h5>DPD Trend</h5>
    </div>
    <BarChart
      width={470}
      height={250}
      data={data}
      margin={{
        top: 15,
        right: 30,
        left: 0,
        bottom: 10,
      }}
    >
      <CartesianGrid stroke="transparent" />
      <XAxis dataKey="name" />
      <YAxis />
      <Tooltip />
      <Legend width={470}/>
      <Bar dataKey="0-30dpd" fill="#C686F8" />
      <Bar dataKey="31-60dpd" fill="#551587" />
      <Bar dataKey="61-90dpd" fill="#8E43C9" />
      <Bar dataKey="90+dpd" fill="#8571F4" />
    </BarChart>
    </>
  );
};

DPDChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      '0-30dpd': PropTypes.number,
      '31-60dpd': PropTypes.number,
      '61-90dpd': PropTypes.number,
      '90+dpd': PropTypes.number,
    })
  ),
};

export default DPDChart;
